<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowAddLabelPopup"  persistent max-width="50%" class="popup-scoring" id="close-label-popup">
                <v-card class="popup-scoring">
                    <v-card-title class="headline">
                        <span class="font-weight-light">Add Label</span>
                        <span  @click="hideLabelPopup()" class="float-right">
                              <img alt="close icon" src="../../../assets/svg/material-icons-alternatives/Close_White.svg" width="24px" height="24px">
                        </span>
                    </v-card-title>
                    <input>
                    <v-card-text>
                        <v-flex xs12 sm6>
                            <v-text-field
                                v-model="label_value"
                                solo
                                label="Add label"
                                clearable
                            ></v-text-field>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="addLabelValue()">OK</v-btn>
                        <v-btn @click="hideLabelPopup()">{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import axios from 'axios';

    export default {
        name: 'AddLabelTestPopup',
        data () {
            return {
                label_value: '',
                validated: false
            }
        },
        computed: {
            ...mapGetters({
                mustShowAddLabelPopup: 'TestStore/getMustShowAddLabelPopup',
                testTree: 'TestStore/getTestTree'
            }),
        },
        methods: {
            ...mapActions({
                showAddLabelPopup: 'TestStore/showAddLabelPopup'
            }),

            hideLabelPopup() {
                this.$store.commit('TestStore/setMustShowAddLabelPopup', false);
            },
            escapeKeyListener: function(evt) {
                if (evt.keyCode === 27) {
                    this.hideLabelPopup();
                }
            },
            addLabelValue() {
                let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/addLabel', {
                    label_value: this.label_value
                });

                axiosRequest.then((response) => {
                    console.log("accept data");
                    console.log(response);
                    this.hideLabelPopup();
                    this.$store.commit('TestStore/setGetTreeData', true);

                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            }
        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListener);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListener);
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .popup-scoring {

        &.card {
            padding: 0;

            .card__title {
                background-color: $color-brand-primary;
                display: block;
                padding: 20px 40px;

                .icon {

                    &:hover {
                        cursor: pointer;
                    }

                }
            }

            .card__text {
                padding: 40px;
            }

            .card__actions {
                padding: 15px 40px;
            }

        }

        p {
            font-size: $font-size-small;
            color: $color-headings-text;
            margin-bottom: 0;
        }

        .ambulance-scoring {
            position: relative;
            top: 7px;
            right: 7px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/components/shared/AddLabelTestPopup.vue